import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";

// helpers/services


// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Label, FormGroup } from "reactstrap";
import Datetime from "react-datetime";

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableSortLabel,
    TableFooter,
    TablePagination,
} from '@material-ui/core';

import "react-datetime/css/react-datetime.css";
import "./custom-style.css";

// -------------------- Styles --------------------
const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: 0,
        fontSize: "14px",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: 0,
        minHeight: "auto",
        fontWeight: 300,
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none",
    },
    tableRow: {
        '&:hover': {
            backgroundColor: '#f5f5f5 !important',
        }
    }
};
const useStyles = makeStyles(styles);

// -------------------- Component --------------------
const PreSendList = (props) => {
    const classes = useStyles();
    const history = useHistory();
    // const user = useSelector((state) => state.auth.user); 

    const location = props.location; // หรือใช้ useLocation() ก็ได้
    const savedState = location.state?.savedFilters;

    const moment = require("moment");
    require("moment/locale/th");

    //const [docDT, setDocDT] = useState(moment().format("YYYY-MM-DD"));
    //const [keyword, setKeyword] = useState("");
    //const [keywordInput, setKeywordInput] = useState("");
    //const [serviceUnitKey, setServiceUnitKey] = useState(161);

    const [diagnosisDate, setDiagnosisDate] = useState(() => {
        // ถ้ามีค่าส่งกลับมา ให้ใช้ค่าเดิม / ถ้าไม่มี ใช้วันปัจจุบัน
        return savedState?.diagnosisDate || moment().format("YYYY-MM-DD");
    });

    const [keyword, setKeyword] = useState(() => {
        return savedState?.keyword || "";
    });

    // keywordInput ต้องแก้ด้วย ไม่งั้นค่าใน State เปลี่ยน แต่ในกล่องข้อความว่างเปล่า
    const [keywordInput, setKeywordInput] = useState(() => {
        return savedState?.keyword || "";
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // UI State
    const [isShowList, setIsShowList] = useState(true);
    const [dateFocus, setDateFocus] = useState(false);
    const [reloadTrigger, setReloadTrigger] = useState(false); // สำหรับ Force Reload

    // Table State
    const [dataList, setDataList] = useState([]);
    const [orderDirection, setOrderDirection] = useState('desc');
    const [orderBy, setOrderBy] = useState('firstName');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);


    // 3. ฝังความทรงจำทุกครั้งที่ Filter เปลี่ยน (สำคัญมาก!)
    useEffect(() => {
        history.replace({
            pathname: location.pathname,
            search: location.search,
            state: {
                ...location.state,
                savedFilters: { // เก็บใส่กล่องชื่อ savedFilters
                    diagnosisDate,
                    keyword
                }
            }
        });
    }, [diagnosisDate, keyword]);

    // -------------------- Fetch Data --------------------
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);

                const response = await axios.post("/api/v1/r506/list", {
                    diagnosisDate: diagnosisDate || undefined,
                    keyword: keyword || undefined
                });

                const _data = response.data?.data || [];
                setDataList(_data);

            } catch (err) {
                console.error(err);
                setError(err.message || "Error");
            } finally {
                setLoading(false);
            }
        };

        if (!diagnosisDate || diagnosisDate.trim() === "") return;
        fetchData();
    }, [diagnosisDate, keyword, reloadTrigger]); // เพิ่ม reloadTrigger

    // -------------------- Sorting Logic --------------------
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedData = () => {
        return dataList.sort((a, b) => {
            let valA = '';
            let valB = '';

            if (orderBy === 'firstName') {
                valA = a.person?.firstName || '';
                valB = b.person?.firstName || '';
            } else if (orderBy === 'diagnosisDate') {
                valA = a.epidemReport?.diagnosisDate || '';
                valB = b.epidemReport?.diagnosisDate || '';
            } else if (orderBy === 'principalDiagnosisIcd10') {
                valA = a.epidemReport?.principalDiagnosisIcd10 || '';
                valB = b.epidemReport?.principalDiagnosisIcd10 || '';
            }

            if (typeof valA === 'string') valA = valA.toLowerCase();
            if (typeof valB === 'string') valB = valB.toLowerCase();

            if (orderDirection === 'asc') {
                return valA < valB ? -1 : 1;
            }
            return valA > valB ? -1 : 1;
        });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // -------------------- Render Main --------------------
    return (
        <div>
            <Grid>
                <Col xs={12} sm={12} md={12} style={{ display: isShowList ? 'block' : 'none' }}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>รายการส่งรายงาน R506</h4>
                        </CardHeader>
                        <CardBody>
                            <div>
                                <Grid>
                                    {/* --- Search Filters --- */}
                                    <Col xs={12} sm={6} md={6}>
                                        <Label>วันที่รับบริการ</Label>
                                        <FormGroup className={"input-lg" + (dateFocus ? " input-group-focus" : "")}>
                                            <i className="far fa-calendar-check fa-2x" style={{ position: 'absolute', left: '30px', zIndex: 1 }} ></i>
                                            <Datetime
                                                value={moment(diagnosisDate).isValid() ? moment(diagnosisDate) : null}
                                                renderYear={(props, year) => <td {...props}>{year + 543}</td>}
                                                inputProps={{
                                                    name: "diagnosisDate", placeholder: "วันที่รับบริการ", readOnly: 'readonly',
                                                    style: { fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000' }
                                                }}
                                                closeOnSelect={true}
                                                dateFormat="D MMMM BBBB" timeFormat={false}
                                                onFocus={() => setDateFocus(true)}
                                                onBlur={() => setDateFocus(false)}
                                                onChange={e => setDiagnosisDate(e.format('YYYY-MM-DD'))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} sm={6} md={6}>
                                        <TSText icon="far fa-edit" label="คำค้นหา" value={keywordInput} placeholder={"ค้นหา 3 ตัวอักษรขึ้นไป"}
                                            onChange={e => {
                                                const v = e.target.value;
                                                setKeywordInput(v);
                                                if (v === "" || v.length >= 3) setKeyword(v);
                                            }}
                                        />
                                    </Col>
                                </Grid>

                                {/* --- Table --- */}
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <TableSortLabel active={orderBy === 'firstName'} direction={orderBy === 'firstName' ? orderDirection : 'asc'} onClick={() => handleRequestSort('firstName')}>
                                                        ชื่อ
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>
                                                    <TableSortLabel active={orderBy === 'diagnosisDate'} direction={orderBy === 'diagnosisDate' ? orderDirection : 'asc'} onClick={() => handleRequestSort('diagnosisDate')}>
                                                        วันที่วินิจฉัย
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>
                                                    <TableSortLabel active={orderBy === 'principalDiagnosisIcd10'} direction={orderBy === 'principalDiagnosisIcd10' ? orderDirection : 'asc'} onClick={() => handleRequestSort('principalDiagnosisIcd10')}>
                                                        ICD-10
                                                    </TableSortLabel>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData()
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((row, index) => {
                                                    const rowIndex = page * rowsPerPage + index;
                                                    return (
                                                        <TableRow key={index} className={classes.tableRow} style={{ backgroundColor: rowIndex % 2 === 0 ? '#f9f9f9' : '#ffffff' }}>
                                                            <TableCell>{row.person?.firstName || '-'}</TableCell>
                                                            <TableCell>{row.epidemReport?.diagnosisDate || '-'}</TableCell>
                                                            <TableCell>{row.epidemReport?.principalDiagnosisIcd10 || '-'}</TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            {dataList.length === 0 && !loading && (
                                                <TableRow>
                                                    <TableCell colSpan={3} align="center" style={{ height: '100px' }}>
                                                        ไม่พบข้อมูล
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[20, 50, 100]}
                                                    count={dataList.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Grid>
        </div>
    );
};

export default PreSendList;